
export default function Footer() {
  return (
    <footer className="bg-white text-[#0A0A6B] py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div className="md:col-span-2">
            <div className="mb-6">
              <img 
                src="https://static.readdy.ai/image/fd7fa72396c6d37ebdaed119979e020e/5f53e0b0b7932ac58bfb3ea1730e8762.png" 
                alt="Flyte Logo" 
                className="h-12 w-auto"
              />
            </div>
            <p className="text-[#0A0A6B]/70 text-lg leading-relaxed mb-8 max-w-md">
              Revolutionizing air travel with AI-powered predictions that keep you ahead of disruptions.
            </p>
            <div className="flex space-x-6">
              <a href="https://www.linkedin.com/company/my-flyte/" className="w-12 h-12 flex items-center justify-center bg-gray-100 hover:bg-[#2C2CE8] hover:text-white rounded-xl transition-colors cursor-pointer">
                <i className="ri-linkedin-line text-xl"></i>
              </a>
              <a href="#" className="w-12 h-12 flex items-center justify-center bg-gray-100 hover:bg-[#2C2CE8] hover:text-white rounded-xl transition-colors cursor-pointer">
                <i className="ri-instagram-line text-xl"></i>
              </a>
            </div>
          </div>
          
          <div>
            <h3 className="text-xl font-bold mb-6 text-[#0A0A6B]">Product</h3>
            <ul className="space-y-4 text-[#0A0A6B]/70">
              <li><a href="#features" className="hover:text-[#2C2CE8] transition-colors cursor-pointer">Features</a></li>
              <li><a href="#" className="hover:text-[#2C2CE8] transition-colors cursor-pointer">Pricing</a></li>
              <li>
                <div className="flex items-center">
                  <a href="#" className="hover:text-[#2C2CE8] transition-colors cursor-pointer mr-2">Demo</a>
                  <span className="text-black text-xs font-medium">Coming Soon</span>
                </div>
              </li>
              <li>
                <div className="flex items-center">
                  <a href="#" className="hover:text-[#2C2CE8] transition-colors cursor-pointer mr-2">Mobile App</a>
                  <span className="text-black text-xs font-medium">Coming Soon</span>
                </div>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-xl font-bold mb-6 text-[#0A0A6B]">Company</h3>
            <ul className="space-y-4 text-[#0A0A6B]/70">
              <li><a href="#about" className="hover:text-[#2C2CE8] transition-colors cursor-pointer">About Us</a></li>
              <li>
                <div className="flex items-center">
                  <a href="#" className="hover:text-[#2C2CE8] transition-colors cursor-pointer mr-2">Careers</a>
                  <span className="text-black text-xs font-medium">Coming Soon</span>
                </div>
              </li>
              <li><a href="#" className="hover:text-[#2C2CE8] transition-colors cursor-pointer">Press</a></li>
              <li><a href="#" className="hover:text-[#2C2CE8] transition-colors cursor-pointer">Contact</a></li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-200 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-[#0A0A6B]/60 text-sm">
              © 2025 Flyte Solutions Inc. All rights reserved.
            </p>
            <div className="flex space-x-8 text-sm text-[#0A0A6B]/60">
              <a href="#" className="hover:text-[#2C2CE8] transition-colors cursor-pointer">Privacy Policy</a>
              <a href="#" className="hover:text-[#2C2CE8] transition-colors cursor-pointer">Terms of Service</a>
              <a href="#" className="hover:text-[#2C2CE8] transition-colors cursor-pointer">Cookie Policy</a>
              <a href="https://readdy.ai/?origin=logo" className="hover:text-[#2C2CE8] transition-colors cursor-pointer">Make with Readdy</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
